export default {"src":"/_next/static/media/instagram-brands.63c8fb26.svg","height":512,"width":448};